export class Transforms
{
    public static toBoolean(v: boolean|string)
    {
         return typeof v === 'string' ? v === 'true' : v;
    }
}